
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Actwentyfourseater() {



    const cardData =
    {
        keyword: 'Ac 24 Seater Tata Bus Hire in Pune',
        heading: 'Amruta Travels: Ac 24 Seater Tata Bus Hire in Pune',
        headingDescription: 'Amruta Travels offers AC 24 Seater Tata Bus Hire in Pune, the perfect solution for small to mid-sized group travel with maximum comfort and safety. Whether it is an office commute, school trip, airport transfer, or family function, our well-maintained 24-seater Tata buses ensure a cool, smooth, and relaxed journey. With air-conditioned interiors, comfortable seating, experienced drivers, and punctual service, Amruta Travels makes every trip efficient and worry-free.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

    "services": [
    {
      "name": "24 Seater AC Tata Bus on Rent in Pune",
      "description": "Amruta Travels offers a 24 Seater AC Tata bus for rent in Pune. This compact bus is perfect for small group tours, religious trips, and corporate events. With comfortable seating, air conditioning, and an experienced driver, your journey will be smooth and enjoyable."
    },
    {
      "name": "Tata AC Mini Bus 24 Seater Pune",
      "description": "Our Tata 24 Seater AC mini bus in Pune provides the perfect solution for small groups looking for a comfortable, affordable, and air-conditioned travel experience. Ideal for family outings, corporate events, and school trips, this mini bus offers both comfort and reliability."
    },
    {
      "name": "24 Seater AC Bus for Corporate Events",
      "description": "For your corporate events in Pune, rent a 24 Seater AC Tata bus that offers comfort and convenience for your employees or clients. Whether it’s a team-building trip, a corporate outing, or transportation to a conference, our buses ensure a smooth and professional experience."
    },
    {
      "name": "24 Seater AC Bus for Wedding Pune",
      "description": "For weddings in Pune, rent a 24 Seater AC Tata bus to transport guests comfortably. With plush seating, air conditioning, and ample space for luggage, our buses provide a hassle-free and elegant transport solution for your big day."
    },
    {
      "name": "Tata AC Bus Hire in Hadapsar",
      "description": "Rent a Tata 24 Seater AC bus in Hadapsar for all your group travel needs. Whether it's for a wedding, corporate event, or family tour, our well-maintained buses are the perfect choice to ensure a comfortable and memorable trip."
    },
    {
      "name": "Tata Bus Hire in Kothrud",
      "description": "Looking to hire a 24 Seater AC Tata bus in Kothrud? Our buses provide the ideal solution for small group travel, offering air-conditioned comfort for all types of events including religious trips, family tours, and school picnics."
    },
    {
      "name": "24 Seater Bus Hire in Pimpri Chinchwad",
      "description": "Rent a 24 Seater AC bus in Pimpri Chinchwad for your group travel needs. Ideal for small family trips, school picnics, or corporate events, our buses are designed for comfort and reliability, ensuring a pleasant journey for all passengers."
    },
    {
      "name": "AC 24 Seater Bus Rental for School Picnic",
      "description": "Planning a school picnic? Rent our 24 Seater AC Tata bus for a comfortable and safe trip for students and teachers. With ample seating and air conditioning, this bus ensures a smooth and enjoyable experience for everyone."
    },
    {
      "name": "24 Seater Tata Bus Hire for Religious Trips",
      "description": "For religious trips, rent our 24 Seater Tata AC bus. Whether you're heading to Shirdi, Nashik, or any other sacred site, our buses offer air-conditioned comfort, spacious seating, and reliable service to make your spiritual journey hassle-free."
    },
    {
      "name": "Pune to Nashik 24 Seater Bus Booking",
      "description": "Book our 24 Seater AC Tata bus for your trip from Pune to Nashik. Whether it's a religious visit or a family trip, our buses ensure a comfortable and pleasant journey with air conditioning, comfortable seating, and experienced drivers."
    },
    {
      "name": "Tata Bus for Small Group Tours",
      "description": "Looking to travel in a small group? Our 24 Seater Tata buses are ideal for intimate group tours. With air conditioning, comfortable seating, and a smooth ride, these buses are perfect for short trips, family outings, or small group vacations."
    },
    {
      "name": "24 Seater Bus for Employee Transport",
      "description": "Rent a 24 Seater bus for employee transportation in Pune. Ideal for corporate events or daily transport, our buses offer comfort and reliability for your workforce, ensuring punctuality and a comfortable commute."
    },
    {
      "name": "Compact AC Bus Hire for Events",
      "description": "For events that require small group transportation, rent our 24 Seater compact AC bus. Perfect for weddings, corporate events, or any special occasion, these buses provide comfort, air conditioning, and ample space for your group."
    },
    {
      "name": "Pune to Lonavala 24 Seater Bus Hire",
      "description": "Plan a trip to Lonavala with our 24 Seater AC Tata bus. With spacious seating, air conditioning, and a professional driver, our buses ensure a comfortable and memorable experience for you and your group while enjoying the scenic beauty of Lonavala."
    },
    {
      "name": "Budget 24 Seater Tata Bus in Pune",
      "description": "Looking for budget-friendly transport options? Rent our 24 Seater Tata bus in Pune. Offering affordable rates without compromising on comfort or safety, these buses are perfect for family trips, corporate outings, and group tours."
    }
  ],
  "tableData": [
    ["24 Seater AC Tata Bus on Rent in Pune", "Tata AC Mini Bus 24 Seater Pune"],
    ["24 Seater AC Bus for Corporate Events", "24 Seater AC Bus for Wedding Pune"],
    ["Tata AC Bus Hire in Hadapsar", "Tata Bus Hire in Kothrud"],
    ["24 Seater Bus Hire in Pimpri Chinchwad", "AC 24 Seater Bus Rental for School Picnic"],
    ["24 Seater Tata Bus Hire for Religious Trips", "Pune to Nashik 24 Seater Bus Booking"],
    ["Tata Bus for Small Group Tours", "24 Seater Bus for Employee Transport"],
    ["Compact AC Bus Hire for Events", "Pune to Lonavala 24 Seater Bus Hire"],
    ["Budget 24 Seater Tata Bus in Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "AC 24 Seater Tata Bus on Hire in Pune",
    "WhyChoosedescription": "Amruta Travels offers the comfortable and reliable AC 24 Seater Tata buses for hire in Pune, perfect for smaller group travel. Whether it’s for a corporate event, family trip, or a wedding function, our Tata buses offer a seamless and enjoyable travel experience."
  },
  {
    "WhyChooseheading": "Comfortable and Air-Conditioned Travel for Small Groups",
    "WhyChoosedescription": "Our AC 24 Seater Tata buses are designed for smaller groups, offering ample space and air-conditioned comfort. With plush seats, air conditioning, and a smooth ride, your group can enjoy a comfortable and relaxed journey to your destination."
  },
  {
    "WhyChooseheading": "Compact Yet Spacious with Modern Amenities",
    "WhyChoosedescription": "Despite being designed for 24 passengers, our Tata buses offer ample space for your group to travel together comfortably. Features such as spacious seats, wide windows, and onboard amenities make the journey enjoyable, whether it's a short city trip or an extended outing."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "At Amruta Travels, we offer competitive and transparent pricing for AC 24 Seater Tata bus rentals. Our rates include fuel, tolls, driver charges, taxes, and all other essential costs—making it easy for you to plan your trip without any hidden fees."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Efficient Travel",
    "WhyChoosedescription": "Our professional drivers are well-trained, licensed, and familiar with Pune’s routes and outstation destinations. They ensure your group reaches the destination safely, on time, and with a smile, offering excellent service throughout your journey."
  },
  {
    "WhyChooseheading": "Ideal for Family Outings, Corporate Travel, and Small Events",
    "WhyChoosedescription": "The 24 Seater Tata bus is the perfect choice for small group travel, whether it's a family outing, corporate trip, school event, or a local wedding transfer. The combination of comfort, affordability, and capacity makes it ideal for such occasions."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for Stress-Free Travel",
    "WhyChoosedescription": "Our fleet of AC 24 Seater Tata buses is regularly serviced, maintained, and cleaned to ensure a smooth, stress-free ride. Each bus is inspected before every trip to ensure top performance and passenger comfort."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
    "WhyChoosedescription": "Booking your AC 24 Seater Tata bus with Amruta Travels is quick and easy. You can book online, over the phone, or by visiting our office. Our 24/7 customer support team is always available to assist with booking, inquiries, or any special requests."
  }
]

















    }

const faqData = [
  {
    question: 'Can I rent an AC 24-seater Tata bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers AC 24-seater Tata buses for rent in Pune. These buses are ideal for small to medium-sized groups, offering a comfortable and convenient travel experience for corporate events, family outings, and group trips.',
  },
  {
    question: 'What amenities are available in the AC 24-seater Tata bus?',
    answer: 'Our AC 24-seater Tata buses are equipped with comfortable plush seats, air conditioning, overhead storage, modern entertainment systems, and a clean and well-maintained interior for a pleasant journey.',
  },
  {
    question: 'Is the AC 24-seater Tata bus available for both local and outstation travel?',
    answer: 'Yes, the AC 24-seater Tata bus is available for local city travel in Pune as well as outstation trips to popular destinations like Lonavala, Mahabaleshwar, Shirdi, and more.',
  },
  {
    question: 'Is a driver included in the AC 24-seater Tata bus rental?',
    answer: 'Yes, all AC 24-seater Tata bus rentals from Amruta Travels come with an experienced and licensed driver who ensures safe, timely, and comfortable travel for all passengers.',
  },
  {
    question: 'How much does it cost to rent an AC 24-seater Tata bus in Pune?',
    answer: 'Rental charges for the AC 24-seater Tata bus vary based on factors like distance, trip duration, and additional services required. Typically, rates start from ₹30–₹40 per km. Please contact us for a customized quote based on your itinerary.',
  },
  {
    question: 'Is the AC 24-seater Tata bus comfortable for long journeys?',
    answer: 'Yes, the AC 24-seater Tata bus is designed to provide a comfortable ride for both short and long journeys. The bus offers ample space and air conditioning to ensure a pleasant experience on extended trips.',
  },
  {
    question: 'Are the AC 24-seater Tata buses well-maintained and sanitized?',
    answer: 'Absolutely. All our AC 24-seater Tata buses are regularly serviced, thoroughly cleaned, and sanitized before every trip to ensure the highest standards of hygiene and safety.',
  },
  {
    question: 'How do I book an AC 24-seater Tata bus in Pune?',
    answer: 'You can easily book an AC 24-seater Tata bus online through our website or by contacting our customer support team. We offer quick booking assistance and transparent pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Vikram Jadhav',
    role: 'Corporate Executive, Pune',
    text: 'We rented an AC 24-seater Tata bus from Amruta Travels for a team-building trip. The bus was very comfortable, clean, and well-maintained. The service was excellent, and we had a smooth, enjoyable ride.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Neha Chavan',
    role: 'Event Organizer',
    text: 'I booked an AC 24-seater Tata bus for a family outing to Mahabaleshwar. The bus was spacious, comfortable, and the air conditioning made our long journey very pleasant. Highly recommend Amruta Travels!',
    rating: 5,
  },
];

























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC 24 Seater Tata Bus Hire in Pune",
  "image": "https://bushireinpune.com/assets/images/24-seater-tata-bus.jpg",
  "description": "Amruta Travels offers AC 24 Seater Tata Bus Hire in Pune for weddings, corporate events, school picnics, employee transport, and outstation tours to Nashik, Lonavala, and more. Our compact Tata buses are ideal for small group tours, offering comfort, air-conditioning, and experienced drivers at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "13589"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/ac-24-seater-tata-bus-hire-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | AC 24 Seater Tata Bus Hire in Pune | Budget Mini Bus for Events & Tours</title>
  <meta 
    name="description" 
    content="Rent a 24 Seater AC Tata Bus in Pune for corporate events, weddings, school picnics, and outstation trips like Nashik or Lonavala. Small group Tata bus rental by Amruta Travels at affordable prices." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/90.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Actwentyfourseater;